import React, {Component} from 'react';
import {connect} from 'react-redux';
import {DialogActions, DialogContentText, DialogContent, DialogTitle, Dialog, Button} from "@material-ui/core";
import {withRouter} from "react-router-dom";
import {bindActionCreators} from "redux";
import ReduxGlobal from "../store/actionreducers/globalView";

class UecareErrorDialog extends Component {

    state = {
        open: false,
    };

    closeErrorDialog = () => {
        this.refreshPage();
    };

    refreshPage = () => {
        window.location.reload();
    };

    render() {

        const {errorDialog} = this.props;

        return (
            <div>
                <Dialog
                    open={this.state.open}
                    onClose={this.closeErrorDialog}
                    {...(errorDialog && errorDialog.props)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{errorDialog.title}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {errorDialog.message}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button color="primary" onClick={this.closeErrorDialog}>
                            刷新頁面
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );


    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        closeErrorDialog: ReduxGlobal.ActionCreator.closeErrorDialog,
    }, dispatch);
}

function mapStateToProps({global: {errorDialog}}) {
    return {errorDialog};
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UecareErrorDialog));



// WEBPACK FOOTER //
// ./src/components/UecareErrorDialog.js